import {
  required,
  email,
  maxLength,
  minLength,
  helpers
} from '@vuelidate/validators'

export function schemaToValidators(schema) {
  const res = {}
  for (const fieldName in schema.properties) {
    res[fieldName] = {}
    if (
      Object.hasOwn(schema.properties[fieldName], 'type') &&
      (schema.properties[fieldName].type === 'string' ||
        schema.properties[fieldName].type.indexOf('string') !== -1)
    ) {
      if ('minLength' in schema.properties[fieldName]) {
        res[fieldName]['minLength'] = minLength(
          schema.properties[fieldName].minLength
        )
      }
      if ('maxLength' in schema.properties[fieldName]) {
        res[fieldName]['maxLength'] = maxLength(
          schema.properties[fieldName].maxLength
        )
      }

      if (
        'email' in schema.properties[fieldName] ||
        schema.properties[fieldName]?.format === 'email'
      ) {
        res[fieldName]['email'] = email
      }
      if ('hostname' in schema.properties[fieldName]) {
        // use https://www.npmjs.com/package/is-valid-hostname or other validator, that supports RFC 1123 hostname
      }
      if ('pattern' in schema.properties[fieldName]) {
        res[fieldName]['pattern'] = helpers.regex(
          new RegExp(schema.properties[fieldName].pattern)
        )
      }
    }

    if (Object.hasOwn(schema.properties[fieldName], 'allOf')) {
      for (const openapiRule of schema.properties[fieldName].allOf) {
        if (
          Object.hasOwn(openapiRule, 'format') &&
          ['has_uppers', 'has_lowers', 'has_numbers'].indexOf(
            openapiRule.format
          ) !== -1
        ) {
          res[fieldName][openapiRule.format] = helpers.withParams(
            { format: openapiRule.format },
            helpers.regex(new RegExp(openapiRule.pattern))
          )
        }

        if ('minLength' in openapiRule) {
          res[fieldName]['minLength'] = minLength(openapiRule.minLength)
        }
        if ('maxLength' in openapiRule) {
          res[fieldName]['maxLength'] = maxLength(openapiRule.maxLength)
        }

        // other formats can be processed here
      }
    }
  }

  for (const fieldName of schema.required) {
    res[fieldName]['required'] = required
  }
  return res
}

export const removeValidationRule = (obj, prop) => {
  const data = Object.assign(obj, {})
  delete data[prop]

  return data
}

export const addValidationsRule = (obj, rule = {}) => {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    acc[key] = value
    if (rule[key]) {
      acc[key] = {
        ...rule[key],
        ...value
      }
    }
    return acc
  }, {})
}
